import { notifications } from 'lib/axios';
import { useMutation } from 'react-query';
import { useNotificationStore } from 'stores/notifications';

export const sendNotification = (data) => {
  return notifications.post('/admin/sendUserNotification', data);
};

export const useSendNotification = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    mutationFn: sendNotification,
    onSuccess: () => {
      addNotification({
        type: 'success',
        title: 'Notification sent successfully!',
      });
    },
    onError: () => {
      addNotification({
        type: 'error',
        title: 'Failed to send notification.',
      });
    },
    ...config,
  });
};
